import { createContext, use } from 'react';

import {
  type LearningPathOrdering,
  type LearningPathsListResponse,
  type StudentLearningPathStatus,
} from '@/features/learning-path';

export const ESSAYS_PAGE_SIZE = 12;

export type EssaysFilters = {
  anoLetivo: number;
  busca: string;
  status?: StudentLearningPathStatus;
  ordenacao: LearningPathOrdering;
};

export type EssaysContextValue = {
  isStudent: boolean;
  schoolId: number | null;
  filters: EssaysFilters;
  setFilters: (patch: Partial<EssaysFilters>) => void;
  page: number;
  setPage: (page: number) => void;
  learningPaths: LearningPathsListResponse | undefined;
  isLoading: boolean;
  isError: boolean;
};

export const EssaysContext = createContext<EssaysContextValue | null>(null);

export function useEssaysContext(): EssaysContextValue {
  const context = use(EssaysContext);
  if (!context) {
    throw new Error('useEssaysContext must be used within an EssaysProvider');
  }
  return context;
}
